module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("\r\n")
    ;  if(factoryKey === 'connection_arrow' && isSourceMultiBranch) { 
    ; __append("\r\n<div class=\"row\">\r\n	<div class=\"col-md-12 nopadding prop-sublabel\">Caption</div>\r\n	<div class=\"col-md-12\">\r\n		<input type=\"checkbox\" name=\"autosummary\" id=\"autosummary\" ")
    ; __append(escapeFn(autosummaryChecked))
    ; __append("></input>Auto-summary\r\n	</div>\r\n</div>\r\n<div class=\"row\">\r\n	<div class=\"col-md-12\">\r\n		<textarea id=\"text\" name=\"text\" style=\" height: 100px; width: 100% \" class= \"")
    ; __append(escapeFn(autoSummaryAreaState))
    ; __append("\"  ")
    ; __append(escapeFn(autoSummaryAreaState))
    ; __append(">")
    ; __append(escapeFn(text))
    ; __append("</textarea>\r\n	</div>\r\n</div>\r\n")
    ; } else if (factoryKey=== 'control_link') { 
    ; __append("\r\n	<div class=\"col-xs-12 propDetail nopadding\">\r\n		<div class=\"nopadding prop-sublabel new-font-size\" style=\"margin-right: 5px; float:left;\">Caption</div>\r\n		<textarea name=\"text\" id=\"text\" class=\"new-font-size ")
    ; __append(escapeFn( text !== '' ? 'translatable' : '' ))
    ; __append("\" data-attr=\"text\" style=\" height: 60px; width: 100% \">")
    ; __append(escapeFn( text ))
    ; __append("</textarea> \r\n	</div>\r\n	\r\n")
    ; } else { 
    ; __append("\r\n<div class=\"propDetail\" >\r\n    ")
    ;  if (mainKind === 'W') { 
    ; __append("\r\n		<div class=\"col-xs-2 prop-sublabel\" style=\"padding-left:0;\">Name</div>\r\n		<div class=\"col-xs-10\"><input type=\"text\" name=\"name\" value=\"")
    ; __append(escapeFn( name ))
    ; __append("\" /></div>\r\n	")
    ;  } else { 
    ; __append("\r\n		<div class=\"col-xs-2 prop-sublabel\" style=\"padding-left:0;\">Caption</div>\r\n		<div class=\"col-xs-10 nopadding-r\">\r\n			<input class=\"")
    ; __append(escapeFn( text !== '' ? 'translatable' : '' ))
    ; __append("\" type=\"text\" data-attr=\"text\" name=\"text\" value=\"")
    ; __append(escapeFn( text ))
    ; __append("\"/>\r\n		</div>\r\n	")
    ;  } 
    ; __append("\r\n</div>\r\n")
    ; }
    ; __append("\r\n")
  }
  return __output;

}